import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Contact(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M5.335 3.64a2.37 2.37 0 013.308.16l1.868 2.012a2 2 0 01.323 2.255l-.725 1.45.101.193c.203.378.517.898.954 1.453.812 1.032 2.019 2.148 3.7 2.743l.915-.572a2 2 0 012.507.316l1.951 2.047c.656.688.772 1.728.283 2.543-1.187 1.981-3.557 3.307-5.981 2.539-5.107-1.618-8.744-5.362-10.925-9.673C2.278 8.466 3.28 5.46 5.335 3.64zM8.07 9.866a1 1 0 01.035-.814l.94-1.88L7.179 5.16a.37.37 0 00-.517-.025c-1.54 1.366-2.095 3.422-1.263 5.067 1.993 3.939 5.255 7.247 9.745 8.67 1.328.42 2.825-.265 3.662-1.661a.112.112 0 00-.015-.135l-1.951-2.047-1.31.818a1 1 0 01-.807.113c-2.426-.702-4.089-2.239-5.13-3.561a12.125 12.125 0 01-1.144-1.743 7.605 7.605 0 01-.378-.789v-.001z",
    clipRule: "evenodd"
  }));
}

export default Contact;